import { Form } from "antd";
import { HTMLProps, forwardRef } from "react";

import { EditableContext } from "../DragAndDrop/context";

export const TableRow = forwardRef<HTMLTableRowElement, HTMLProps<HTMLTableRowElement>>((props, ref) => {
    const [form] = Form.useForm();

    return (
        <Form form={form} component={false}>
            <EditableContext.Provider value={form}>
                <tr ref={ref} {...props} />
            </EditableContext.Provider>
        </Form>
    );
});
